import * as React from 'react';
import { useContext, useState } from 'react';
import {
  Button,
  Dialog, FormControl,
  Grid, TextField,
  Typography
} from '@mui/material';
import { DialogRoot } from './DialogRoot';
import Box from '@mui/material/Box';
import { UploadFile } from '@mui/icons-material';
import { TitleDialog } from './TitleDialog';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/env';
import { OrganisationContext } from '../../App';

type UploadVideoProps = {
  open: boolean,
  handleClose: () => void,
  title?: string,
}

export const ImportVideoFromLink = ({
  open,
  handleClose,
  title = 'Import video'
}: UploadVideoProps) => {
  const { selectedOrganisation } = useContext(OrganisationContext);
  const [postSubmit, setPostSubmit] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [link, setLink] = useState<string>('');
  const [busy, setBusy] = useState<boolean>();

  const importVideo = async (e) => {

    e.preventDefault();

    if (busy) {
      return;
    }

    if (!/^https/.test(link)) {
      setPostSubmit(true);
      return;
    }

    setPostSubmit(undefined);
    setBusy(true);
    setErrorMessage('')
    await axios.get(`${getApiBaseUrl()}/video-clip/${selectedOrganisation}/import-from-link?link=${link}`)
      .catch((message) => {
        setPostSubmit(false);
        setErrorMessage('Internal server error. Please check the browser log for more details.');
        console.error(message);
        return {
          data: {
            status: 'error',
            filename: '',
          }
        };
      });
    setBusy(false);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth={'sm'}>
      <DialogRoot handleClose={handleClose}>
        <form onSubmit={importVideo}>
          <TitleDialog>{title}</TitleDialog>
          <Box sx={{ pl: 4, pr: 4, pb: 4 }}>
            <Grid container spacing={2} style={{ marginTop: 0 }}>
              {postSubmit !== undefined && <Grid item xs={12}>
                {postSubmit && <Typography color={'green'} fontSize={'12px'}>Video successfully
                  imported</Typography>}
                {!postSubmit &&
                  <Typography color={'red'} fontSize={'12px'}>{errorMessage}</Typography>}
              </Grid>}
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField id="importLink"
                             value={link}
                             required
                             label="Public youtube/instagram/tiktok url"
                             onChange={({ target: { value } }) => {
                               setLink(value);
                             }}
                             variant="outlined"
                             type={'url'}
                             autoFocus
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Grid container justifyContent={'flex-end'}>
                  <Button disabled={busy} type="submit" variant={'contained'}
                          startIcon={<UploadFile/>}>{busy ? 'Uploading..' : 'Upload'}</Button>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </form>
      </DialogRoot>
    </Dialog>
  );
};
